import type { ModalPortalStyles } from './tooltip-portal-comp.types';
import getColors from '../../../global/colors';

const tooltipStyle = {
  borderRadius: '8px',
  fontWeight: '600',
  marginBottom: '0px',
  padding: '10px',
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
  zIndex: 1002,
} as const;

export const getTooltipStyle = (
  additionalStyles: ModalPortalStyles,
  isDark?: boolean,
) => ({
  style: {
    // this is the stylename in the package for the tooltip
    backgroundColor: getColors(isDark).primary700,
    color: getColors(isDark).surface1,
    ...tooltipStyle,
    ...(additionalStyles?.style || {}),
  },
  arrowStyle: {
    // this is the stylename in the package for the arrow
    color: getColors(isDark).primary700,
    ...(additionalStyles?.arrowStyle || {}),
  },
});
